import { useEffect, useState } from 'react';

import useApplicationStatusContext from './useApplicationStatusContext';
import useUnitAccountId from './useUnitAccountId';

const DEFAULT_TIMEOUT = 100;

function useSkeleton(hideSkeletonCondition, delay = DEFAULT_TIMEOUT) {
  const [status, setStatus] = useState(true);
  const { isEmptyUnitAccountId } = useUnitAccountId();
  const { isInvalidStatus } = useApplicationStatusContext();

  const setShow = () => {
    setStatus(true);
  };

  const setHide = () => {
    setStatus(false);
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    const isHideSkeleton =
      status && (hideSkeletonCondition || isEmptyUnitAccountId || isInvalidStatus);
    if (isHideSkeleton) {
      const id = setTimeout(setHide, delay);
      return () => clearTimeout(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hideSkeletonCondition, isEmptyUnitAccountId, isInvalidStatus]);

  return [status, setShow, setHide];
}

export default useSkeleton;
